export const isMobile = /iPhone|iPad|iPod|Android|tablet/i.test(
  navigator.userAgent,
);

export const FORMAT_DATE = "DD/MM/YYYY hh:mm";
